__turbopack_context__.v({
  "btn": "toaster-module-scss-module__MAPVoG__btn",
  "description": "toaster-module-scss-module__MAPVoG__description",
  "title": "toaster-module-scss-module__MAPVoG__title",
  "toast": "toaster-module-scss-module__MAPVoG__toast",
  "toasts": "toaster-module-scss-module__MAPVoG__toasts",
});
